export default "__VITE_ASSET__BjQpaAZG__"